"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkSystemRequirements = exports.getFeatureFlags = exports.Features = void 0;

var common_1 = require("../../utils/common");

var Errors_1 = require("../Errors");

var Errors_2 = require("@skbkontur/plugin-js/lib/common/Errors");

var Features;

(function (Features) {
  Features["StoreType"] = "StoreType";
  Features["InstallCertificate"] = "InstallCertificate";
  Features["InstallWithoutPasswordRequest"] = "InstallWithoutPasswordRequest";
})(Features = exports.Features || (exports.Features = {}));

exports.getFeatureFlags = function (pluginVersion) {
  var flags = {
    StoreType: false,
    InstallCertificate: false,
    InstallWithoutPasswordRequest: false
  };

  if (common_1.compareVersions(pluginVersion, '3.5') >= 0) {
    flags.StoreType = true;
    flags.InstallCertificate = true;
  }

  if (common_1.compareVersions(pluginVersion, '3.9') >= 0) {
    flags.InstallWithoutPasswordRequest = true;
  }

  return flags;
};

exports.checkSystemRequirements = function (currBowser, unsupportedBrowsers, supportedOS) {
  if (common_1.checkBrowser(currBowser, unsupportedBrowsers)) {
    return new Errors_2.CommonError('Browser is unsupported', null, Errors_1.DisplayedErrorCodes.UnsupportedBrowser);
  }

  if (supportedOS.length && !common_1.checkOS(currBowser, supportedOS)) {
    return new Errors_2.CommonError('Operation system is unsupported', null, Errors_1.DisplayedErrorCodes.UnsupportedOS);
  }

  return;
};